import styled from 'styled-components';

export const StoreStateTreatmentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ allowOverflow }) => (allowOverflow ? '' : 'overflow: hidden;')}
  ${({ stretched }) => (stretched ? 'height: 100%;' : '')}
`;
